import React, {useEffect, useState} from 'react';
import './_club-competition-tile.scss';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../store/configureStore';
import CalendarIcon from '../../../assets/icons/calendar.svg'
import ArrowRight from '../../../assets/icons/arrow-right-white.svg'
import ClipboardIcon from '../../../assets/icons/clipboard.svg'
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '../../../assets/icons/icon-info.svg';
import AccordionItem from "../accordion-item/accordion-item";
import ClockIcon from "../../../assets/icons/clock.svg";
import {PLAYER_FEE_EXCLUDED_STATES} from "../../../../constants/Config";

const baseClass = 'competition-tile-container'

const ClubCompetitionTileVersion2 = (props: any): JSX.Element => {
  const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);

  const convertDateFormat = (date: any) => {
    const newDate = new Date(date);
    const timezoneDate = newDate.toLocaleString('en-US', {timeZone: timeZone});
    const timeZoneDateObj = new Date(timezoneDate);
    return {
      dateObj: newDate,
      timezoneDate: timeZoneDateObj,
      formattedDate: `${newDate.getDate()} ${newDate.toLocaleString('en-US', {
        timeZone: timeZone,
        month: 'short'
      })} ${newDate.getFullYear()}`,
    };
  }

  const timeZone = useSelector((state: RootState) => state.widgetConfigurationSettings.timeZone);
  const hideCompetitionFees = useSelector((state: RootState) => state.widgetConfigurationSettings.hideCompetitionFees);
  const getSeasonStartDate = props.competitionDetails && props.competitionDetails.seasonOpenDate ? convertDateFormat(props.competitionDetails.seasonOpenDate) : null;
  const getSeasonEndDate = props.competitionDetails && props.competitionDetails.seasonEndDate ? convertDateFormat(props.competitionDetails.seasonEndDate) : null;
  const getRegEndDate = props.competitionDetails && props.competitionDetails.regEndDate ? convertDateFormat(props.competitionDetails.regEndDate) : null;
  const getRegStartDate = props.competitionDetails && props.competitionDetails.regOpenDate ? convertDateFormat(props.competitionDetails.regOpenDate) : null;
  const formatDetails = useSelector((state: RootState) => state.widgetConfigurationSettings.formats);
  const [isRegistrationAvailable, setIsRegistrationAvailable] = useState(false);
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);

  const findLogoByPlayHqFormat = (playHqFormat: string) => {
    const matchingFormat = formatDetails.find((format: {
      playHqFormats: string | any[];
    }) => format.playHqFormats.includes(playHqFormat));

    // Return the logo if a matching format is found
    return matchingFormat ? matchingFormat.logo : null;
  }

  useEffect(() => {
    const regStartDate = getRegStartDate ? getRegStartDate.dateObj : null;
    const regEndDate = getRegEndDate ? getRegEndDate.dateObj : null;
    const userDate = new Date();
    if (regStartDate && regEndDate) {
      if (userDate >= regStartDate && userDate <= regEndDate) {
        setIsRegistrationAvailable(true);
      } else {
        setIsRegistrationAvailable(false);
      }
    }
  }, [getRegStartDate, getRegStartDate?.dateObj, getRegEndDate, getRegEndDate?.dateObj, formatDetails]);

  let buttonLabel = 'Register';
  if (props.competitionDetails.type && props.competitionDetails.type === 'PARTICIPANT_TO_SEASON') {
    buttonLabel = 'Register Player'
  } else if (props.competitionDetails.type && props.competitionDetails.type === 'SOCIAL_TEAM_TO_SEASON') {
    buttonLabel = 'Register Team'
  }

  return (
    <div className={`${baseClass}--version-2 ${tenant}`} key={props.index}>
      <div className={`${baseClass}--tile-col`}>
        {props.competitionDetails.name && (
          <div
            className={`${baseClass}--title`}>{props.competitionDetails.name} {props.competitionDetails.aliasName ? ` - ${props.competitionDetails.aliasName}` : ''}</div>
        )}

        {props.competitionDetails.format && (
          <div className={`${baseClass}--logo-container`}>
            <img src={props.competitionDetails.logo ? props.competitionDetails.logo : findLogoByPlayHqFormat(props.competitionDetails.format)} className={'competition-logo-image'}
                 alt="logo"/>
          </div>
        )}

      </div>

      {props.competitionDetails.gender && (
        <div className={`${baseClass}--competition-gender`}>{props.competitionDetails.gender}</div>
      )}

      {props.competitionDetails.regOpenDate && (
        <div
          className={`${baseClass}--registration-date`}><img
          src={ClipboardIcon}
          alt={'Registration'}/> Registration: {getRegStartDate?.formattedDate} - {getRegEndDate?.formattedDate}</div>
      )}

      {props.competitionDetails.seasonOpenDate && (
        <div className={`${baseClass}--season-date`}><img src={CalendarIcon} alt={'Season'}/> Season
          dates: {getSeasonStartDate?.formattedDate} - {getSeasonEndDate?.formattedDate} {props.competitionDetails.sessionCount ? `• ${props.competitionDetails.sessionCount} sessions` : ''}
        </div>
      )}

      {props.competitionDetails.sessions && props.competitionDetails.sessions.length > 0 && (
        <AccordionItem accordionTitle={'Session times'}
                       sessionsList={props.competitionDetails.sessions} iconBeforeText={ClockIcon}/>
      )}

      <div className={`${baseClass}--footer`}>
        <div className={`${baseClass}--button-container`}>
          {props.competitionDetails.regFormURL && props.competitionDetails.regFormVisible && isRegistrationAvailable && (
            <a href={props.competitionDetails.regFormURL} target='_blank' className={'button-text'}>
              {buttonLabel}
              <img src={ArrowRight} alt={'arrow'}/>
            </a>
          )}
        </div>

        {!hideCompetitionFees && (props.competitionDetails.playerFees >= 0 || props.competitionDetails.teamFee >= 0) && (!PLAYER_FEE_EXCLUDED_STATES.includes(props.state)) && (
          <div className={`${baseClass}--player-fee`}>
            <span>From</span>
            <div
              className={'fee-text'}>${!(props.competitionDetails.type && props.competitionDetails.type === 'SOCIAL_TEAM_TO_SEASON') ? props.competitionDetails.playerFees : props.competitionDetails.teamFee}</div>
            {props.extraFeesApplicable && (
              <Tooltip title={props.extraFeesApplicableMessage} placement="top-start" open={tooltipIsOpen}
                       onOpen={() => setTooltipIsOpen(true)}
                       onClose={() => setTooltipIsOpen(false)} arrow>
                <img alt={'info'} src={InfoIcon} onClick={() => setTooltipIsOpen(!tooltipIsOpen)}/>
              </Tooltip>
            )}
          </div>
        )}

      </div>
    </div>
  )
}

export default ClubCompetitionTileVersion2;
